export class IPEError {
  constructor(
    public description?: string,
    public errorNumber?: string,
    public levelCode?: string
  ) { }
}
